module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ppelv18-305d97e651b28da17c960af3f2db0fa3.jpg";